export enum RouteNames {
  ROOT = '/',
  SIGN_UP = '/signup',
  SIGN_IN = '/signin',
  ENABLE_ADMIN = '/1_secret_2_admin_3_enabler_4',
  FEATURE_FLAGS = '/internal/featureflags',
  LICENSES = '/licenses',
  LOGIN = '/login',
  SIGNUP = '/signup',
  MEETING_LINK = '/:meetingRoute/meetinglink',
  CREATE_MEETING = '/create/:meetingType?',
}
